<template>
    <!-- Theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <DailyTreasureViewOne @reset-show-treasure-popup="resetShowTreasurePopup" />
    </div>

    <!-- theme two -->
    <div v-if="themeStore.themeIndex === 2">
        <DailyTreasureViewTwo @get-deposit-claim="() => emits('getDepositClaim')"
            @reset-show-treasure-popup="resetShowTreasurePopup" />
    </div>

    <!-- theme Three -->
    <div v-if="themeStore.themeIndex === 3">
        <DailyTreasureViewThree @reset-show-treasure-popup="resetShowTreasurePopup" />
    </div>
</template>

<script setup lang="ts">
import { useThemeStore } from '@/stores/theme';
import DailyTreasureViewTwo from '@/themes/themeTwo/dailyTreasure/dailyTreasureView.vue';
import DailyTreasureViewOne from '@/themes/themeOne/dailyTreasure/dailyTreasureView.vue';
import DailyTreasureViewThree from '@/themes/themeThree/dailyTreasure/dailyTreasureView.vue';
const themeStore = useThemeStore()
const emits = defineEmits(['getDepositClaim', 'resetShowTreasurePopup'])
const resetShowTreasurePopup = () => {
    emits('resetShowTreasurePopup')
}
</script>
